export enum NetworkErrorPattern {
  /** Generic network error from browser APIs */
  NETWORK_ERROR = 'NetworkError',
  /** CORS policy violation, common with Safari ITP and browser privacy settings */
  CORS = 'CORS',
  /** Fetch API network failure (Chrome, Edge) */
  FAILED_TO_FETCH = 'Failed to fetch',
  /** Chrome network error prefix */
  NET_ERR = 'net::ERR_',
  /** React Native and some browsers */
  NETWORK_REQUEST_FAILED = 'Network request failed',
  /** Safari fetch reachability failure */
  LOAD_FAILED = 'Load failed',
  /** axios default message for transport-level failures (no response) */
  AXIOS_NETWORK_ERROR = 'Network Error',
}

export const NETWORK_ERROR_PATTERNS_LOWERCASE = Object.values(NetworkErrorPattern).map(pattern =>
  pattern.toLowerCase(),
);
